import { createAsyncThunk } from "@reduxjs/toolkit";
import {
    getHomeLayout as getHomeLayoutApi,
    createHomeLayout as createHomeLayoutApi,
    updateHomeLayout as updateHomeLayoutApi,
    deleteHomeLayout as deleteHomeLayoutApi
} from "../../helpers/helper";
import { toast } from "react-toastify";

export const getHomeLayout = createAsyncThunk("HomeLayout/getHomeLayout", async () => {
    try {
        const response = await getHomeLayoutApi();
        return response;
    } catch (error) {
        return error;
    }
});

export const createHomeLayout = createAsyncThunk("HomeLayout/createHomeLayout", async (homeLayout: any) => {
    try {
        const response = createHomeLayoutApi(homeLayout);
        const data = await response;
        toast.success("HomeLayout Added Successfully", { autoClose: 2000 });
        return data;
    } catch (error) {
        toast.error("HomeLayout Added Failed", { autoClose: 2000 });
        return error;
    }
});

export const updateHomeLayout = createAsyncThunk("HomeLayout/updateHomeLayout", async (dataArr: any) => {
    try {
        const response = updateHomeLayoutApi(dataArr);
        const data = await response;
        toast.success("HomeLayout Updated Successfully", { autoClose: 2000 });
        return data;
    } catch (error) {
        toast.error("HomeLayout Updated Failed", { autoClose: 2000 });
        return error;
    }
});

export const deleteHomeLayout = createAsyncThunk("HomeLayout/deleteHomeLayout", async (homeLayoutId: any) => {
    try {
        const response = deleteHomeLayoutApi(homeLayoutId);
        console.log(response);
        toast.success("HomeLayout Deleted Successfully", { autoClose: 2000 });
        return homeLayoutId;
    } catch (error) {
        toast.error("HomeLayout Deleted Failed", { autoClose: 2000 });
        return error;
    }
})
